export default {"src":"/_next/static/media/logo.e88d95f2.svg","height":254,"width":1646};